import {
    orderNoNormalColumn,
    dateNormalColumn,
    addressNormalColumn,
    numberNormalColumn,
    brandingCompanyNormalColumn,
    personNameNormalColumn,
    personPhoneNormalColumn,
} from '@/components/tablePage/common/normalColumn';
import { getLabelByValue, purchaseOrderStatusDict } from '@/dicts';

// 采购单列表 表头
const purchaseOrderColumns = [
    { ...orderNoNormalColumn('采购单号'), fixed: 'left' },
    numberNormalColumn('采购总数量', 'totalQuantity'),
    { title: '采购总金额(元)', key: 'totalAmount', minWidth: 130 },
    addressNormalColumn('收货地址', 'distributorAddress'),
    {
        title: '状态',
        key: 'status',
        minWidth: 100,
        render: (h, p) => {
            return h('div', [getLabelByValue(purchaseOrderStatusDict, p.row.status)]);
        },
    },
    brandingCompanyNormalColumn(),
    personNameNormalColumn('制单人', 'submitUser'),
    dateNormalColumn('制单时间', 'submitTime'),
];

// 采购产品 表头 (有合计无法使用公共js的column)
const purchasePruductColumns = [
    { title: '序号', key: 'no', minWidth: 100 },
    { title: '商品名称', key: 'productName', minWidth: 220 },
    {
        title: '规格',
        key: 'skuSpec',
        minWidth: 120,
        render: (h, p) => {
            return h('div', [p.row.skuSpec || '-']);
        },
    },
    { title: '采购数量', key: 'quantity', minWidth: 120 },
    { title: '单价(元)', key: 'amount', minWidth: 120 },
    { title: '采购金额(元)', key: 'totalAmount', minWidth: 120 },
];

// 地址 表头
const addressColumns = [
    addressNormalColumn(),
    personNameNormalColumn('联系人'),
    personPhoneNormalColumn('联系手机', 'mobile'),
];

// 采购商品表头
const purchaseGoodsColumns = [
    { title: '序号', key: 'number', minWidth: 80 },
    { title: '商品名称', key: 'brandProductId', minWidth: 220, slot: 'brandProductId' },
    { title: '规格', key: 'skuSpec', minWidth: 120, slot: 'skuSpec' },
    { title: '采购数量', key: 'quantity', minWidth: 120, slot: 'quantity' },
    {
        title: '单位(元)',
        key: 'realNumPrice',
        minWidth: 120,
        render: (h, p) => {
            return h('div', [p.row.realNumPrice || p.row.minimumPrice || '-']);
        },
    },
    {
        title: '采购金额(元)',
        key: 'purchaseAmount',
        minWidth: 120,
        render: (h, p) => {
            return h('div', [p.row.purchaseAmount || '-']);
        },
    },
    { title: '操作', key: 'action', minWidth: 80, slot: 'action' },
];

export { purchaseOrderColumns, purchasePruductColumns, addressColumns, purchaseGoodsColumns };
